import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Center,
  Flex,
} from '@chakra-ui/react';
import { Stack } from '@main/complykit/components/stack';
import { Text } from '@main/complykit/components/text';
import { ReactNode } from 'react';

type DomainSetupAccordionProps = {
  icon: ReactNode;
  title: ReactNode;
  description: ReactNode;
  badge?: ReactNode;
  isExpanded: boolean;
  onToggle: (expanded: boolean) => void;
  children: ReactNode;
};

export const DomainSetupAccordion = ({
  icon,
  title,
  description,
  badge,
  isExpanded,
  onToggle,
  children,
}: DomainSetupAccordionProps) => (
  <Accordion index={isExpanded ? 0 : -1} onChange={(index) => onToggle(index === 0)} allowToggle>
    <AccordionItem borderWidth="1px" borderRadius="md" overflow="hidden">
      <AccordionButton
        p={4}
        gap={3}
        flexDirection={{ base: 'column', sm: 'row' }}
        alignItems={{ base: 'stretch', sm: 'center' }}
        _hover={{ bg: 'gray.50' }}
      >
        <Flex flex={1} minW={0} alignItems="center" gap={3} textAlign="left">
          <Center w={10} h={10} flexShrink={0} borderRadius="md" bg="blue.50" color="blue.500">
            {icon}
          </Center>
          <Stack gap={0}>
            <Text size="sm" weight="semibold">
              {title}
            </Text>
            <Text size="sm" color="muted" lines={2}>
              {description}
            </Text>
          </Stack>
        </Flex>
        <Flex
          alignItems="center"
          justifyContent={{ base: 'space-between', sm: 'flex-end' }}
          gap={3}
          ml={{ sm: 4 }}
        >
          {badge}
          <AccordionIcon />
        </Flex>
      </AccordionButton>
      <AccordionPanel p={5} borderTopWidth="1px">
        {children}
      </AccordionPanel>
    </AccordionItem>
  </Accordion>
);
